import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'

export interface GetNamesRequest {
  ClientID: number
  IDs: number[]
}

// The /v1/persons/names response is a bare array of name records — no
// pagination wrapper and, deliberately, no contact details. Unlike the full
// persons List, this endpoint is authorized at the client level only (no
// per-person IDOR check), so a camp admin can resolve staff names for people
// in their own client without the all-person role.
export interface RawPersonName {
  PersonID: number
  First: string
  Preferred: string
  Last: string
}

export interface GetNames<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const getNames: GetNames<GetNamesRequest, RawPersonName[]> = (
  http,
  params,
) => {
  const {ClientID, IDs} = params

  const queryParams: string[] = [`clientid=${ClientID}`]
  IDs.forEach((id) => queryParams.push(`id=${id}`))
  const query = `?${queryParams.join('&')}`

  return http.request<RawPersonName[]>({
    method: 'GET',
    url: `/v1/persons/names${query}`,
    headers: {Release: 'Beta'},
  })
}
